import classNames from 'classnames';
import { PopupInput } from '../elements/PopupInput';
import Spinner from '../elements/Spinner';
import { StateUpdater } from 'preact/hooks';

interface DiscountInputProps {
  className?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errorMessage?: string;
  isLoading: boolean;
  isLabelShrink: boolean;
  setIsLabelShrink: StateUpdater<boolean>;
  onEnterPress?: (event: any) => Promise<void>;
}

export function DiscountInput({
  className,
  value,
  onChange,
  errorMessage,
  isLoading,
  onEnterPress,
  setIsLabelShrink,
  isLabelShrink,
}: DiscountInputProps) {
  return (
    <div className={`flex content-between gap-2 ${className}`}>
      <PopupInput
        type="text"
        name="discount"
        inputPlaceholder="Discount code"
        inputValue={value}
        onChange={onChange}
        disabled={isLoading}
        errorMessage={errorMessage}
        isLabelShrink={isLabelShrink}
        setIsLabelShrink={setIsLabelShrink}
        className="DiscountScreen-Input"
        onKeyDown={async (e) => {
          if (e.key === 'Enter') {
            await onEnterPress?.(e);
          }
        }}
      />

      <button
        data-cy="discount-screen-input-button"
        className={classNames(
          'GiftBox-Discount-Screen-Button font-semibold text-white rounded-[10px] w-12 py-2.5 px-5 h-7 box-content flex justify-center items-center bg-primary-600 hover:bg-primary-700 active:bg-primary-800 disabled:bg-gray-200',
          {
            'bg-gray-200': isLoading,
          },
        )}
        disabled={isLoading}
        type="submit"
      >
        {isLoading ? <Spinner /> : 'Apply'}
      </button>
    </div>
  );
}
